module.exports = __webpack_public_path__ + "img/cdmecono.2dd69972.svg";